"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getH5Images = getH5Images;
exports.getPcImages = getPcImages;
const webp_1 = require("../../../../../utils/webp");
const bullUrl = require('./images/h5/seq_0_0.png');
const titleUrl = require('./images/h5/seq_0_59.png');
const pcTitleUrl = require('./images/pc/title.png');
const pcBullUrl = require('./images/pc/bull.png');
async function getH5Images() {
    const isSupportWebp = await (0, webp_1.checkWebpFeatures)();
    if (isSupportWebp) {
        return {
            bull: 'https://static.futunn.com/upload/00000Stockpageicon/output_mini_webpmux-46f74f6da667fca2afd97db4a6ce21d7.webp?_=1768905605563', //eslint-disable-line max-len
            title: 'https://static.futunn.com/upload/00000Stockpageicon/output_mini_webpmux-76eba782f503a78b7e326f746450ed6e.webp?_=1768907396290' //eslint-disable-line max-len
        };
    }
    return {
        bull: bullUrl,
        title: titleUrl
    };
}
async function getPcImages() {
    const isSupportWebp = await (0, webp_1.checkWebpFeatures)();
    if (isSupportWebp) {
        return {
            title: 'https://static.futunn.com/upload/000aPelosi/output_mini-63ec4702435102c1dafab659667e20d5.webp?_=1768974539897', //eslint-disable-line max-len
            bull: 'https://static.futunn.com/upload/000aPelosi/output_mini-76beec93a0506030fd30787a89464155.webp?_=1768974370821' //eslint-disable-line max-len
        };
    }
    return {
        bull: pcBullUrl,
        title: pcTitleUrl
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBVUEsa0NBWUM7QUFFRCxrQ0FZQztBQXBDRCxvREFBOEQ7QUFDOUQsTUFBTSxPQUFPLEdBQUcsT0FBTyxDQUFDLHlCQUF5QixDQUFDLENBQUM7QUFDbkQsTUFBTSxRQUFRLEdBQUcsT0FBTyxDQUFDLDBCQUEwQixDQUFDLENBQUM7QUFDckQsTUFBTSxVQUFVLEdBQUcsT0FBTyxDQUFDLHVCQUF1QixDQUFDLENBQUM7QUFDcEQsTUFBTSxTQUFTLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUM7QUFNM0MsS0FBSyxVQUFVLFdBQVc7SUFDN0IsTUFBTSxhQUFhLEdBQUcsTUFBTSxJQUFBLHdCQUFpQixHQUFFLENBQUM7SUFDaEQsSUFBSSxhQUFhLEVBQUUsQ0FBQztRQUNoQixPQUFPO1lBQ0gsSUFBSSxFQUFFLCtIQUErSCxFQUFFLDZCQUE2QjtZQUNwSyxLQUFLLEVBQUUsK0hBQStILENBQUMsNkJBQTZCO1NBQ3ZLLENBQUM7SUFDTixDQUFDO0lBQ0QsT0FBTztRQUNILElBQUksRUFBRSxPQUFPO1FBQ2IsS0FBSyxFQUFFLFFBQVE7S0FDbEIsQ0FBQztBQUNOLENBQUM7QUFFTSxLQUFLLFVBQVUsV0FBVztJQUM3QixNQUFNLGFBQWEsR0FBRyxNQUFNLElBQUEsd0JBQWlCLEdBQUUsQ0FBQztJQUNoRCxJQUFJLGFBQWEsRUFBRSxDQUFDO1FBQ2hCLE9BQU87WUFDSCxLQUFLLEVBQUUsK0dBQStHLEVBQUUsNkJBQTZCO1lBQ3JKLElBQUksRUFBRSwrR0FBK0csQ0FBQyw2QkFBNkI7U0FDdEosQ0FBQztJQUNOLENBQUM7SUFDRCxPQUFPO1FBQ0gsSUFBSSxFQUFFLFNBQVM7UUFDZixLQUFLLEVBQUUsVUFBVTtLQUNwQixDQUFDO0FBQ04sQ0FBQyJ9